import {
  FETCH_PAGE_DATA,
  FETCH_COMPONENT_DATA,
  FETCH_EVENTS_DATA,
  FETCH_ARTICLES_DATA,
  FETCH_NEWSLETTER_DATA
} from './types'

const initialState = {
  pageData: {},
  moduleComponentData: {},
  eventsData: [],
  articlesData: [],
  newsletterData: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAGE_DATA:
      return Object.assign({}, state, {
        pageData: {
          ...state.pageData,
          [action.payload.page]: action.payload.data
        }
      })
    case FETCH_EVENTS_DATA:
      return Object.assign({}, state, {
        eventsData: {
          ...state.eventsData,
          [action.payload.id]: action.payload.data
        }
      })
    case FETCH_ARTICLES_DATA:
      return {
        ...state,
        articlesData: action.payload.data
      }
    case FETCH_NEWSLETTER_DATA:
      return {
        ...state,
        newsletterData: action.payload.data
      }
    case FETCH_COMPONENT_DATA:
      return Object.assign({}, state, {
        moduleComponentData: {
          ...state.moduleComponentData,
          [action.payload.page]: [
            ...state.moduleComponentData[action.payload.page],
            { id: action.payload.id, data: action.payload.data }
          ]
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/contentEvents/reducer.js